// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminNews_wrapper__prwqJ","container":"AdminNews_container__Or9zT"};